/**
 * Spacing token definitions.
 * Scale based on 8px base unit for consistent layout spacing.
 */

export const spacingTokens = {
    xs: '4px',      // 0.5 units
    sm: '8px',      // 1 unit
    md: '16px',     // 2 units
    lg: '24px',     // 3 units
    xl: '32px',     // 4 units
    xxl: '48px',    // 6 units
    xxxl: '64px',   // 8 units
} as const;
